import MultiStepFormLayout from "@/components/layout/multiStepFormLayout/MultiStepFormLayout";
import AdminInformation from "./AdminInformation";
import SecurityAndAccess from "./SecurityAndAccess";
import { useFormikContext } from "formik";
import { IUser } from "../../types";
import useCreateMspAdmin from "@/hooks/query/admins/useCreateMspAdmin";
import Toast from "@/components/kit/Toast";
import useUpdateProfile from "@/hooks/query/admins/useUpdateProfile";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

const steps = [
  {
    stepNumber: 1,
    title: "Admin information",
    component: <AdminInformation />,
  },
  {
    stepNumber: 2,
    title: "Security & Access",
    component: <SecurityAndAccess />,
  },
];

const MultiStepWrapper = () => {
  const { values, errors } = useFormikContext<IUser>();
  const navigate = useNavigate();
  const { mutate: createMspAdmin, isPending } = useCreateMspAdmin();
  const { mutate: updateProfile } = useUpdateProfile();
  const queryClient = useQueryClient();
  const handleSave = () => {
    const { profile, ...rest } = values;
    //i want if phonenumber and personal email be empty removed from the payload
    const payload = { ...rest };
    if (!rest.phoneNumber) {
      delete (payload as any).phoneNumber;
    }
    if (!rest.personalEmail) {
      delete (payload as any).personalEmail;
    }
    if (!rest.birthDate) {
      delete (payload as any).birthDate;
    }
    createMspAdmin(payload, {
      onSuccess: async (data) => {
        await queryClient.invalidateQueries({ queryKey: ["users"] });
        if (profile) {
          updateProfile({ adminId: data.id, profile: profile as File });
        }
        navigate(`/admins`);

        Toast({
          status: "success",
          description: "MSP admin created successfully",
        });
      },
    });
  };
  const { userOrganizations, ...restErrors } = errors;

  return (
    <MultiStepFormLayout
      title="Add MSP admin"
      description="To access MSP and Billing , follow the instructions carefully."
      // saveButtonText="save"
      finishButtonText="Save"
      isNextDisabled={() => {
        const { userOrganizations, roleId, ...restErrors } = errors;

        return !Object.keys(restErrors).length;
      }}
      showSaveButton={false}
      showCancelButton
      onCancel={() => {
        navigate("/admins");
      }}
      isValid={!Object.keys(restErrors).length}
      steps={steps}
      onSubmit={handleSave}
      isLoading={isPending}
    />
  );
};

export default MultiStepWrapper;
